import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/services/notification.service";
import { Subject } from "rxjs";
import { DirectieSeriiService } from "../directie-serii.service";
import Swal from "sweetalert2";
import { PermissionsService } from "src/app/services/permissions.service";
import { DialogService } from "src/app/services/dialog.service";
import { AddAlocareResponsabileCompartimentComponent } from "./add-alocare-responsabile-compartiment/add-alocare-responsabile-compartiment.component";
import { DataTablesResponse } from "src/app/interfaces/data-table-response.interface";


@Component({
    selector: 'app-alocare-responsabile-compartiment',
    templateUrl: './alocare-responsabile-compartiment.component.html',
    styleUrls: ['./alocare-responsabile-compartiment.component.scss']
})
export class AlocareResponsabileCompartimentComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    isLoading = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.directieSeriiService.assignedUsersListDTUrl;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { directie_id: number, compartiment_id: number | null },
        private dialogRef: MatDialogRef<AlocareResponsabileCompartimentComponent>,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private directieSeriiService: DirectieSeriiService,
        private notificationService: NotificationService,
        private http: HttpClient,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 10,
            order: [[0, "asc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                // Important, add directie_id and compartiment_id to dtParams
                dataTablesParameters.directie_id = this.data.directie_id;
                dataTablesParameters.compartiment_id = this.data.compartiment_id;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    orderable: true,
                    data: 'id',
                },
                {
                    title: 'Nume Utilizator',
                    orderable: false,
                    data: 'user_name',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                            <div class="d-flex align-center justify-content-left">
                                <button class="action-btn delete me-1" title="Sterge">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                                </button>
                            </div>
                            `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (deleteIcon) {
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteEntry(id);
                    });
                }
            }
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    deleteEntry(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să ștergeți această înregistrare!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.directieSeriiService.deleteAssignedUser(id).subscribe(
                    () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    });
            }
        });
    }

    addResponsabil() {
        const dialogRef = this.dialog.open(AddAlocareResponsabileCompartimentComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                directie_id: this.data.directie_id,
                compartiment_id: this.data.compartiment_id
            }
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
